// Freestar placement names, as configured in Freestar's dashboard (FAD). Freestar
// has no Thor placements, so Thor uses these prod ones too.
export const STICKY_FOOTER_PLACEMENT = 'hudl-com_sticky_footer';
export const VIDEO_PAGE_SIDEBAR_PLACEMENT = 'hudl-com_Display_VideoPageTest';
